/**
 * libphonenumber utils в основном бандле (без отдельного chunk и без async load)
 */
import intlTelInput from 'intl-tel-input';
import intlTelInputUtils from 'intl-tel-input/build/js/utils.js';

type IntlTelGlobal = typeof intlTelInput & {
    utils?: typeof intlTelInputUtils;
};

const globalIntl = intlTelInput as IntlTelGlobal;

if (!globalIntl.utils) {
    globalIntl.utils = intlTelInputUtils;
}

export function isIntlUtilsLoaded(): boolean {
    return !!globalIntl.utils;
}

export const intlUtilsReady: Promise<void> = isIntlUtilsLoaded()
    ? Promise.resolve()
    : Promise.reject(new Error('[PhoneMask] intl-tel-input utils missing from bundle'));
